import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import Intro from './Intro';
import Menu from './Menu';
import Qa from './Qa';
import Complete from './Complete';
import { getResource } from '../../../tools';

const useStyles = makeStyles(theme => ({
  Diy: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& > div': {
      width: 700,
      maxWidth: '100%',
      background: '#fff',
      padding: 20,
      maxHeight: '100%',
      overflow: 'auto',
    },
  },
  action: {
    textAlign: 'center',
    verticalAlign: 'middle',
    '& button': {
      margin: '0 3px',
      verticalAlign: 'middle',
    },
    '& > span': {
      display: 'inline-block',
      minWidth: 53,
      verticalAlign: 'middle',
      userSelect: 'none',
    },
  },
  '@media(max-width: 850px)': {

  }
}));

function Diy(props) {
  const classes = useStyles();
  const [complete, setComplete] = useState([]);
  const [state, setState] = useState({ type: 'menu' });
  const [data, setData] = useState(null);
  const { exercise, startStats, finishExercise, action, type, close } = props.exerciseProps;

  useEffect(() => {
    startStats(type);
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    const url = `Diy/diy${exercise.identifier}.json`;
    getResource(url)
      .then((response) => {
        const data = response.exercises;
        setData(data);
        setComplete(new Array(data.length).fill(false));
      }).catch(e => console.log(e));
  }, [exercise]);

  const start = () => {
    const idx = state.idx;
    const type = data[idx].type;
    setState({ type: type, idx });
  }

  const toMenu = () => {
    setState({ type: 'menu' })
  }

  const completePart = () => {
    const compl = [...complete];
    compl[state.idx] = true;
    setComplete(compl);
    if (compl.indexOf(false) === -1) {
      finishExercise();
    }
  }

  if (!data) return <h3>Wczytuję dane...</h3>

  return (
    <div className={classes.Diy}>
      <div>
        {state.type === 'menu' && <Menu data={data} close={close} exercise={exercise} complete={complete} setState={setState} />}
        {state.type === 'intro' && <Intro state={state} setState={setState} data={data} start={start} />}
        {state.type === 'qa' && <Qa state={state} setState={setState} data={data} close={toMenu} action={action} completePart={completePart} />}
        {state.type === 'complete' && <Complete state={state} setState={setState} data={data} close={toMenu} action={action} completePart={completePart} />}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    media: state.media,
    mobile: state.mobile,
  }
}

export default connect(mapStateToProps)(Diy);